import { Component, OnInit, Input } from '@angular/core';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-show-file',
    templateUrl: './show-file.component.html',
    styleUrls: ['./show-file.component.scss'],
    imports: [NgIf, SweetAlert2Module]
})
export class ShowFileComponent implements OnInit {
  @Input() fileUrl: string;
  imgEl: string;

  constructor() { }

  ngOnInit() {
    this.imgEl = `<img src="${environment.file}${this.fileUrl}" style="max-width:100%" />`;
    this.fileUrl = environment.file + this.fileUrl;
  }

}
